<template>
    <div class="vx-card p-6">
      <div slot="no-body" class="tab-container px-6">
        <div class="tab-text">
          <div class = "vx-row">
              <div class="vx-col md:w-1/2 w-full mt-2">
                <vs-input
                v-model="form.sourceId" class="w-full"
                placeholder="Nhập mã nguồn"
                label="Id nguồn"
                type="number"
                />
              </div>

              <div class="vx-col md:w-1/2 w-full mt-2">
                <vs-input
                v-model="form.name" class="w-full"
                placeholder="Nhập tên nguồn"
                label="Tên nguồn"
                name="name"
                v-validate="'required'"
                data-vv-validate-on="blur"
                />
                <span class="text-danger text-sm">{{
                  errors.first("name")
                }}</span>
              </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="vs-input--label">Nguồn Website</label>
              <vs-textarea
              v-model="form.domain"
              class="w-full placeholderDomain"
              placeholder="Nhập nguồn Website"
              name="urlWebsite"
              v-validate="'required|url'"
              />
              <span class="text-danger text-sm">
                {{errors.first("urlWebsite")}}
              </span>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="vs-input--label">Nguồn Facebook</label>
              <vs-textarea
              v-model="form.domainFacebook" class="w-full placeholderDomain"
              placeholder="Nhập nguồn Facebook"
              v-validate="'required|url'"
              name="urlFacebook"
              />
              <span class="text-danger text-sm">
                {{errors.first("urlFacebook")}}
              </span>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 text-size" :disabled ="!validateForm" @click = "saveChanges">{{`${isUpdate ?
                  'Cập nhật': 'Tạo mới'}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2 text-size" type="border" color="warning" @click="$router.go(-1)">Quay lại
                </vs-button>
              </div>
            </div>
          </div>
      </div>
    </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
export default {
    components:{
      vSelect
    },
    data(){
        return{
            articalFacebook:null,
            articalWebsite:null,
            articleName:null,
            isUpdate:false,
            form:{
              id:null,
              name:null,
              domain:null,
              domainFacebook:null,
              sourceId:null
            },
            optionalArtical:[],
            valueSelected:null,
        }
    },
    computed:{
        validateForm(){
            return !this.errors.any();
        },
        selectedArtical:{
          get(){
            let object = this.optionalArtical.find(el => this.valueSelected === el.value);
            if(!object) return null;
            return{
              label: object.label,
              value: this.valueSelected
            }
          },
          set(object){
            this.valueSelected = object ? object.value : null;
          }
        }
    },
    methods:{
      selectedRadioFacebook: function(){
          const payload = {
            pageNumber: 0,
            pageSize: 20
          }
          this.$processor.post('website/get-all', payload).then(() => {
          })
      },
      selectedRadioWebsite: function(){
          const payload = {
            pageNumber: 0,
            pageSize: 20
          }
          this.$processor.post('website/get-all', payload).then((response) => {
            this.optionalArtical = response.data.content.map(artical => {
              return {
                label: artical.name,
                value: artical.id
              }
            })
          })
      },
      initScreen(){
        const id = this.$route.query.id;
        const payload = {
          id:id
        }
        if(id){
          this.isUpdate = true;
          this.$processor.post('classify-source/find-by-id',payload).then((response) => {
            const result = response.data;
            this.form.name = result.sourceName;
            this.form.sourceId = result.sourceId;
            this.form.domain = result.source;
            this.form.domainFacebook = result.sourceFacebook;
            this.isUpdate = true;
          })
        }
      },
      validURL: function(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
      },
      saveChanges: function(){
        const checkNull=this.form.domain;
        const checkNullFacebook=this.form.domainFacebook;
        const checkNullName=this.form.name;
        if(checkNull==null || checkNullFacebook==null || checkNullName==null){
          return this.$vs.notify({
            text:'Không được để trống các trường',
            icon: 'icon-alert',
            iconPack:'feather',
            color:'danger'
          })
        }
        const resultDomain = this.form.domain.split(',');
        const resultDomainFacebook = this.form.domainFacebook.split(',');
        resultDomain.forEach(element => {
          const result = this.validURL(element);
          if(!result){
            return this.$vs.notify({
              text:'Sai định dạng website',
              icon:'icon-alert',
              iconPack:'feather',
              color:'danger'
            })
          }
        });
        resultDomainFacebook.forEach(element => {
          const result = this.validURL(element);
          if(!result){
            return this.$vs.notify({
              text:'Sai định dạng nguồn Facebook',
              icon:'icon-alert',
              iconPack:'feather',
              color:'danger'
            })
          }
        })
        const payloadCreate = {
          sourceId: this.form.sourceId,
          sourceName: this.form.name,
          source: this.form.domain,
          sourceFacebook:this.form.domainFacebook
        }

        const payloadUpdate = {
          id:this.$route.query.id,
          sourceId: this.form.sourceId,
          sourceName: this.form.name,
          source: this.form.domain,
          sourceFacebook: this.form.domainFacebook
        }
        this.$vs.loading();
        const payload = this.isUpdate ? payloadUpdate : payloadCreate;
        const path = this.isUpdate ? '/classify-source/update' : '/classify-source/create'
        this.$processor.post(path, payload).then(() => {
          this.$vs.loading.close();
          this.$router.push('/user/classify-source')
          return this.$vs.notify({
            text: `${this.isUpdate ? 'Cập nhật' : 'Thêm mới'} thành công`,
            icon: 'icon-alert',
            iconPack:'feather',
            color:'primary'
          })
        }).catch((err) =>{
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        })
      },
    },

    async created(){
      this.initScreen();
    }
};
</script>
<style scoped>
.placeholderDomain ::placeholder{
  font-size: .95rem !important;
  color: rgba(0,0,0,.4) !important;
}
</style>
